module.exports = __webpack_public_path__ + "img/dashboard_automation_mono_icon.5e92d1e6.svg";